import { Image as ImageIcon, Volume2, Video, X } from 'lucide-react';

const iconByType = { image: ImageIcon, audio: Volume2, video: Video };

export default function ReferenceMediaGroup({ items = [], onInsert, onRemove }) {
  if (!items.length) return null;
  return (
    <div className="space-y-1.5">
      <p className="text-[10px] text-gray-400">参考素材</p>
      <div className="flex flex-wrap gap-1.5">
        {items.map(item => {
          const Icon = iconByType[item.mediaType] || ImageIcon;
          const invalid = item.active === false || !item.node;
          return (
            <div key={item.bindingId || item.nodeId}
              className={`group flex max-w-[210px] items-center gap-1.5 rounded-lg border px-2 py-1.5 text-[11px] ${invalid
                ? 'border-red-200 bg-red-50 text-red-500 dark:border-red-400/20 dark:bg-red-500/10'
                : 'border-[#d9d0c2] bg-[#f7f3eb] text-stone-600 dark:border-white/[0.08] dark:bg-white/[0.05] dark:text-gray-300'}`}>
              {item.mediaType === 'image' && item.node?.data?.url
                ? <img src={item.node.data.url} alt="" className="h-5 w-5 rounded object-cover" />
                : <Icon size={12} className="shrink-0 text-[#7d719e]" />}
              <button type="button" onClick={() => !invalid && onInsert?.(item)} disabled={invalid}
                title={invalid ? '引用已失效' : `插入 @${item.alias}`}
                className="min-w-0 flex-1 truncate text-left disabled:cursor-not-allowed">
                <span className="font-medium">{item.alias}</span>
                {item.label && <span className="ml-1 text-gray-400">· {item.label}</span>}
              </button>
              {onRemove && item.edgeId && (
                <button type="button" onClick={() => onRemove(item)} title="移除参考素材"
                  className="shrink-0 rounded p-0.5 text-gray-400 opacity-60 hover:bg-black/5 hover:text-red-500 group-hover:opacity-100 dark:hover:bg-white/10">
                  <X size={10} />
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
